import { doc, setDoc } from "firebase/firestore";
import { db } from "../conf/firebaseConfig";

/**
 * Claims an unowned session, or creates its ownership record before hydration.
 * Security rules enforce caller ownership without changing existing answers.
 */
export const claimSurveySession = async (
  sessionId: string,
  userId: string
): Promise<void> => {
  const sessionRef = doc(db, "surveySessions", sessionId);
  await setDoc(sessionRef, { userId }, { merge: true });
};
